import { Icon } from "@mui/material";

const Check = () => (
  <Icon
    baseClassName="material-symbols-outlined"
    sx={{ fontWeight: 300, fontSize: "1rem", verticalAlign: "text-bottom" }}
  >
    check
  </Icon>
);

export const consumerPlanData = {
  columns: [
    {
      label: "",
      target: "",
      scope: "row",
    },
    {
      label: "Free",
      target: "free",
      align: "center",
    },
    {
      label: "Stanza+",
      target: "plus",
      align: "center",
    },
  ],
  body: {
    "UNLIMITED ACCESS": {
      "Calendar subscriptions": {
        free: <>2</>,
        plus: <>Unlimited</>,
      },
      "Members-only calendars": {
        free: <></>,
        plus: <Check />,
      },
    },
    "SUBSCRIBE WITH CONFIDENCE": {
      "Sync across devices": {
        free: <>Manual</>,
        plus: <>Automatic</>,
      },
      "Event updates": {
        free: <>24-48 hrs</>,
        plus: <>Real-time</>,
      },
      "\"Last updated\" timestamp": {
        free: <></>,
        plus: <Check />,
      },
      "Force refresh": {
        free: <></>,
        plus: <Check />,
      },
    },
    "DISCOVER & ORGANIZE": {
      "Group calendars into one": {
        free: <></>,
        plus: <Check />,
      },
      "Personalized events feed": {
        free: <></>,
        plus: <Check />,
      },
      "Recommendation emails": {
        free: <></>,
        plus: <Check />,
      },
      "Add individual events": {
        free: <></>,
        plus: <Check />,
      },
    },
    EXTRAS: {
    "Customer service": {
        free: <>Help Desk</>,
        plus: <>Email</>,
        },
      "Early access to new features": {
        free: <></>,
        plus: <Check />,
      },
      "Suggest new calendars": {
        free: <></>,
        plus: <Check />,
      },
    },
  },
};
